'use strict';

module.exports = {
  hits: require('./hits.js'),
  popularIn: require('./popularIn.js')
};



// WEBPACK FOOTER //
// ./node_modules/autocomplete.js/src/sources/index.js